import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
import { ConnectionType } from '../../store/schema/ConnectionType';
export var updateAdvancedConnectionType = mutatorAction('updateAdvancedConnectionType', function (connectionType) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.connectionType = connectionType;
    store.connectAdvancedState.incomingPort =
        connectionType === ConnectionType.ImapSmtp ? '993' : '995';
    if (connectionType === ConnectionType.SmtpOnly) {
        store.connectAdvancedState.remoteSend = true;
    }
});
//# sourceMappingURL=updateAdvancedConnectionType.js.map